import { normalizeFilestorePath } from "../../../document";
import { DocumentFileRow } from "../document-file-row";
import { InfoDropdown } from "../info-dropdown";
import "./document-block.scss";

interface DocumentBlockProps {
  title: string;
  fileName?: string;
  documentUrl?: string;
  fileId?: string;
  docType?: any;
  docId?: string;
  isInfoHidden?: boolean;
  disableLinkAction?: boolean;
}

export const DocumentBlock = ({
  title,
  fileName,
  documentUrl,
  fileId,
  docType,
  docId,
  isInfoHidden = false,
  disableLinkAction = false,
}: DocumentBlockProps) => {
  if (!fileName) {
    return null;
  }

  return (
    <div className="document-block">
      <div className="document-block__title">{title}</div>
      <div className="document-block__content">
        <DocumentFileRow
          className="document-block__row"
          linkClassName="document-block__name"
          fileName={fileName}
          documentUrl={
            documentUrl ? normalizeFilestorePath(documentUrl) : documentUrl
          }
          fileId={fileId}
          disableLinkAction={disableLinkAction}
          actions={
            docType && docId && !isInfoHidden ? (
              <InfoDropdown docType={docType} docId={docId} />
            ) : null
          }
        />
      </div>
    </div>
  );
};
